import { NgModule } from '@angular/core';
import { BlankCapsule } from './capsule/blank.capsule';

@NgModule({
  providers: [
    { provide: BlankCapsule, useClass: BlankCapsule }
  ]
})
export class CapsuleModule {}
